import { Typography } from 'hype-ds';
import { HandleOpenDialogProps } from 'stores/dialog/interfaces';
import { handleOpenDialog } from 'stores/dialog/middleware';
import { store } from 'stores/store';

export function openForbiddenModal() {
	store.dispatch(
		handleOpenDialog({
			...forbiddenActionDialogConfig(),
			ignoreAutoClose: false,
		}),
	);
}

function forbiddenActionDialogConfig(): HandleOpenDialogProps {
	return {
		hideFooter: true,
		heading: {
			title: 'Funcionalidade não disponível neste acesso',
			iconOptions: { name: 'info', color: '--text-primary', size: '20px' },
			showCloseButton: true,
		},
		content: {
			description: (
				<>
					<Typography.Label.M>Você está navegando na jornada exclusiva do distribuidor.</Typography.Label.M>
					<Typography.Paragraph.M color="--text-primary">
						Se deseja usar esta funcionalidade, finalize essa sessão e realize o seu login na plataforma do Hympar.
					</Typography.Paragraph.M>
				</>
			),
		},
	};
}
